/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { Fragment, FC, useState, ReactNode, ReactElement } from "react"
import { MenuHeader } from "components/MenuHeader"

export interface WithMenuHeaderProps {
  backLink?: string
}
export interface WithMenuHeaderInjectedProps {
  setHeaderTitle: (string: string) => void
  setBackLink: (string?: string) => void
  setMenuButtonOverlay: (overlay: ReactElement) => void
  setContent: (content: ReactNode) => void
  setMenuVisibleChangeFunc: (
    func: ((visible: boolean) => void) | undefined,
  ) => void
}

export const WithMenuHeader = ({
  backLink = undefined,
}: WithMenuHeaderProps = {}) => {
  return (
    WrappedComponent: React.ComponentType<WithMenuHeaderInjectedProps>,
  ) => {
    const Component: FC = props => {
      const [headerTitle, setHeaderTitle] = useState("")

      const [backLinkState, setBackLink] = useState(backLink)

      const [menuButtonOverlay, setMenuButtonOverlay] = useState<
        ReactElement | undefined
      >()

      const [contentState, setContent] = useState<ReactNode | undefined>()
      const [menuVisibleChangeFunc, setMenuVisibleChangeFunc] = useState<
        ((visible: boolean) => void) | undefined
      >()

      return (
        <Fragment>
          <MenuHeader
            title={headerTitle}
            backLink={backLinkState}
            menuButtonOverlay={menuButtonOverlay}
            content={contentState}
            menuVisibleChangeFunc={menuVisibleChangeFunc}
          />
          <div className="page-content">
            <WrappedComponent
              {...props}
              setHeaderTitle={title => setHeaderTitle(title)}
              setBackLink={link => setBackLink(link)}
              setMenuButtonOverlay={overlay => setMenuButtonOverlay(overlay)}
              setContent={content => setContent(content)}
              setMenuVisibleChangeFunc={func => {
                setMenuVisibleChangeFunc(() => func)
              }}
            />
          </div>
        </Fragment>
      )
    }
    return Component
  }
}
